// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2RRgz","inputWrap":"Table_inputWrap__2qVUg","col":"Table_col__2ILcB","bmiTooltip":"Table_bmiTooltip__2vXZC"};